import { styled } from 'styled-components';

import { colors, transition } from '#/theme/theme';

export const CmsEmailCampaignSignupDoubleBlockButtonGroup = styled.div`
  display: flex;
  margin-bottom: 10px;
  border: 1px solid ${colors.white};
  border-radius: 8px;
  overflow: hidden;
`;

export const CmsEmailCampaignSignupDoubleBlockToggleButton = styled.button`
  width: 50%;
  padding: 12px;
  transition: all ${transition};

  justify-content: center;
  font-size: 16px;

  &:not([data-selected]) {
    color: ${colors.white};

    &:hover,
    &:focus {
      color: ${colors.white};
      background-color: ${colors.brandGreen};
    }
  }

  &[data-selected] {
    color: ${colors.brandBlue};
    background: ${colors.white};
  }
`;
